import { useClearSelectedProducts } from '@in-life/hooks';
import { Button } from '@utilitywarehouse/hearth-react';
import { WarningMediumIcon } from '@utilitywarehouse/hearth-react-icons';
import { color } from '@utilitywarehouse/hearth-tokens/js';
import { useNavigate } from 'react-router-dom';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';
import { paths } from '@constants/paths';
import { clearFormPersistStorage } from '@utils/storagePropertyManagement';

const ICON = <WarningMediumIcon color={color.red[700]} />;
const HEADING = 'Leave this page?';
const DESCRIPTION = 'You will be returned back to the start of the order.';

const InLifeStartAgainDialog = () => {
  const dialog = useDialog(DialogID.IN_LIFE_START_AGAIN);
  const navigate = useNavigate();
  const { clearProducts, loading } = useClearSelectedProducts();

  const handleCancel = () => {
    dialog.setOpen(false);
  };

  const handleStartAgain = async () => {
    try {
      await clearProducts();
    } catch {
      return;
    } finally {
      dialog.setOpen(false);
    }

    clearFormPersistStorage();
    navigate(paths.root);
  };

  return (
    <Dialog
      id={dialog.id}
      data-testid="inlife-start-again-dialog"
      onClose={handleCancel}
      heading={HEADING}
      image={ICON}
      description={DESCRIPTION}
    >
      <DialogActions style={{ justifyContent: 'center' }}>
        <Button
          type="button"
          variant="outline"
          data-testid="inlife-start-again-cancel-button"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="solid"
          colorScheme="destructive"
          data-testid="inlife-start-again-confirm-button"
          onClick={handleStartAgain}
          loading={loading}
        >
          Start Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { InLifeStartAgainDialog };
